import { TableCell } from "@mui/material";
import { FC } from "react";
import TableActions, { TableActionsProps } from "./TableActions";

type TableActionsCellProps = TableActionsProps;

const TableActionsCell: FC<TableActionsCellProps> = (props) => {
  return (
    <TableCell>
      <TableActions {...props} />
    </TableCell>
  )
}

export default TableActionsCell;
